import styled from 'styled-components'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;

  padding: 24px;
  box-sizing: border-box;

  border-radius: 12px;
  background: var(--background-page-faded, #fafafa);

  animation: slideIn 0.3s ease-out forwards;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const CardHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const CardHeaderTitle = styled.label`
  color: var(--foreground-neutral, #14171f);

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  margin-left: 4px;
  flex: 1;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ButtonArrowContainer = styled.button`
  cursor: pointer;
  border: none;
  outline: none;

  width: 36px;
  height: 36px;

  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;

  background-color: rgba(0, 0, 0, 0);
`

export const ButtonContainer = styled.button`
  cursor: pointer;
  border: none;
  outline: none;

  width: 36px;
  height: 36px;

  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;

  border-radius: 6px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-base, #fff);

  margin-left: 8px;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding-left: 40px;
  box-sizing: border-box;
`

export const SwitchContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const SubmitButton = styled.button`
  width: 328px;
  margin-top: 16px;

  border: none;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 36px;
  padding: 8px 12px;
  box-sizing: border-box;

  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%),
    var(--Foreground-Secondary, #2fb609);

  background-blend-mode: soft-light, normal;

  /* Raised */
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 2px 3px 0px rgba(0, 0, 0, 0.1);

  color: var(--On-background-Primary, #fff);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  cursor: pointer;
`

export const Label = styled.div`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const ArrowImg = styled.img<{ open?: boolean }>`
  transform: rotate(${({ open }) => (open ? '0' : '180')}deg);
`

export const SwitchLabel = styled.span`
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
